var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('b-jumbotron',[_c('h1',[_vm._v("Bienvenid@ "),_c('small',[_vm._v("Escoge una opción")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }